import useSoftpullModalEvents from '~/hooks/flp/useSoftpullModalEvents';
import AllCreditTypes from './AllCreditTypes';
import Hero from './Hero';
import MarketingFAQ from './MarketingFAQ';
import SocialProofSection from './SocialProof';
import UnlockRealPayments from './UnlockRealPayments/UnlockRealPayments';
import PageViewAnalytics from '../PageViewAnalytics';

export default function MarketingContent() {
  useSoftpullModalEvents(true);

  return (
    <>
      <PageViewAnalytics page="marketing" />
      <Hero />
      <AllCreditTypes />
      <UnlockRealPayments />
      <SocialProofSection />
      <MarketingFAQ />
    </>
  );
}
